import { render } from "./FrmManageProductionOutputs.vue?vue&type=template&id=1b2db5e5"
import script from "./FrmManageProductionOutputs.vue?vue&type=script&lang=js"
export * from "./FrmManageProductionOutputs.vue?vue&type=script&lang=js"

import "./FrmManageProductionOutputs.vue?vue&type=style&index=0&id=1b2db5e5&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__